import React from "react";
import { Button, Card, CardProps, Space, Typography } from "antd";
import omit from "lodash/omit";
import get from "lodash/get";
import styled from "@emotion/styled";

const Content = styled.div`
  display: flex;
  flex-direction: column;
`;

const StyledCard = styled(Card)`
  border: 1px solid #c4c8d0;
  height: 390px;
  display: flex;
  flex-direction: column;
  .ant-card-head {
    .ant-card-head-title {
      white-space: pre-wrap;
    }
    max-height: 70px;
    border-bottom: none;
  }

  .ant-card-body {
    flex-grow: 3;
    .textContent {
      display: -webkit-box;
      -webkit-line-clamp: 4;
      -webkit-box-orient: vertical;
      overflow: hidden;
    }
    .label {
      color: #8991a0;
      font-size: 12px;
      font-weight: 400;
      line-height: 16px;
      letter-spacing: 0.005em;
      text-align: left;
    }
  }
  .ant-card-actions {
    background: none;
    border-top: none;
    li {
      display: flex;
      justify-content: flex-start;
      margin-left: 24px;
    }
  }
`;

type FieldProps = {
  name: string;
  label: string;
  parser?: (values: any) => any;
};
export const DoCCard = (
  props: Partial<
    CardProps & {
      data: Record<string, any>;
      defaultPlaceHolder: string | React.ReactElement;
      fields: FieldProps[];
      onClickEdit: (data: Record<string, any>) => void;
      disabled?: boolean;
    }
  >
) => {
  const {
    defaultPlaceHolder,
    fields = [],
    data,
    onClickEdit,
    disabled,
    ...cardProps
  } = props;

  return (
    <StyledCard
      actions={[
        <Button
          type="primary"
          ghost
          disabled={disabled}
          onClick={() => {
            onClickEdit && onClickEdit(data ?? {});
          }}
        >
          Edit
        </Button>,
      ]}
      bordered={false}
      {...cardProps}
    >
      <Content>
        {fields.map(({ name, label, parser }, index) => {
          const value = parser
            ? parser(get(data, name, null))
            : get(data, name, null);
          return (
            <Space direction="vertical" key={`${index}_${name}`}>
              <Typography.Text className="label">
                {label || defaultPlaceHolder}
              </Typography.Text>
              <Typography.Paragraph className="textContent">
                {value || defaultPlaceHolder}
              </Typography.Paragraph>
            </Space>
          );
        })}
      </Content>
    </StyledCard>
  );
};
